// Copyright (c) 2019 Deere & Company
import './index.scss';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import SelectList from './select-list';

const OptionsDropDown = props => (
    <section className={props.className}>

        {props.label ? (
            <label className={`${props.isRequired ? 'form-group-title asterisk-after' : 'form-group-title optional-criteria'}`}>
                <FormattedMessage id={props.label} />
            </label>
        ) :
            null
        }
        <span className={`asterisk-icon ${props.isRequired ? 'mandatory' : ''}`}><i className="fa fa-asterisk" /></span>
        <SelectList
            alwaysCallOnChange={props.alwaysCallOnChange}
            isPlaceholderTranslated={props.isPlaceholderTranslated}
            onChange={props.onChange}
            optionDisplayAttributes={props.optionDisplayAttributes}
            optionKey={props.optionKey}
            options={props.options}
            placeholder={props.placeholder}
            selectedValue={props.selectedValue}
            showPlaceholder={props.showPlaceholder}
            disabled={props.disabled}
        />
    </section>
);

OptionsDropDown.displayName = 'OptionsDropDown';
OptionsDropDown.propTypes = {
    alwaysCallOnChange: PropTypes.bool,
    className: PropTypes.string,
    isPlaceholderTranslated: PropTypes.bool.isRequired,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    optionDisplayAttributes: PropTypes.arrayOf( PropTypes.string ).isRequired,
    optionKey: PropTypes.string.isRequired,
    options: PropTypes.arrayOf( PropTypes.object ).isRequired,
    placeholder: PropTypes.string,
    selectedValue: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ),
    showPlaceholder: PropTypes.bool,
    disabled: PropTypes.bool,
};
OptionsDropDown.defaultProps = {
    alwaysCallOnChange: false,
    showPlaceholder: true,
};

export default OptionsDropDown;
